export default "__VITE_ASSET__kGO_h7C2__"